import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  const heading = t('notFoundPage.heading');

  useEffect(() => {
    document.title = heading;

    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [heading]);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-200 bg-white/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="mx-auto max-w-6xl flex items-center justify-between px-6 py-3">
          <Link to="/">
            <img src="/assets/logo/logo-full-dark-text.png" alt="badges.ninja" className="h-9" />
          </Link>
        </div>
      </header>

      <main className="flex min-h-[calc(100vh-57px)] items-center justify-center bg-gray-50 px-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">{heading}</h1>
          <p className="text-gray-500 mb-6">{t('notFoundPage.message')}</p>
          <div className="flex items-center justify-center gap-4">
            <a href="/#verify" className="text-sm font-medium text-primary-600 hover:underline">
              {t('landing:wedge.verifiable.cta')}
            </a>
            <Link to="/" className="text-sm font-medium text-primary-600 hover:underline">
              {t('award.verify.goHome')}
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
